<template>
    <div class="simple-form">
        <el-form :model="devcDef" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="form-group">
                <div class="form-label">
                    <label class="required">财务类别</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="assetKindName">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="devcDef.assetKindName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="setAssetKind()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">资产属性</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="assetNature">
                        <span>{{ assetNatureMap[devcDef.assetNature] }}</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label :class="devcDef.deprMethodCode != 'NONE' ? 'required' : ''">使用年限(月)</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="durableLife" :rules="{validator: checkDurableLife, trigger: 'blur'}">
                        <el-input class="width-1-5x" type="number" v-model="devcDef.durableLife"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>折旧与分摊规则</span>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">规则名称</label>
                </div>
                <div class="form-value">
                    <span>{{ devcDef.deprSpecName || '' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">规则编码</label>
                </div>
                <div class="form-value">
                    <span>{{ devcDef.deprSpecCode || '' }}</span>
                </div>
            </div>
        </el-form>
    </div>

</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {openAssetKindListSelectDlg} from '../categ/selectDlg'

    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-def-fiscal-save',
        desc: '资产定义财务信息保存',
        props: {
            defId: {
                type: Number,
                default: null
            },
            assetType: {
                type: Number,
                default: 0
            },
            fiscalAudit: { // 是否为财务审核
                type: Boolean,
                default: false
            }
        },
        data: function () {
            let checkNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            return {
                devcDef: {
                    assetType: 0,
                    assetKindId: null,
                    assetKindName: null,
                    assetKindCode: null,
                    assetNature: null,
                    deprSpecId: null,
                    deprSpecCode: null,
                    deprSpecName: null
                },
                allotLogicTypeList: getEnumList("allotAcntMethod"),
                rules: {
                    assetKindName: [{validator: checkNull, trigger: 'change'}],
                    deprSpecCode: [{validator: checkNull, trigger: 'change'}]
                },
                //
                deviceKindMaps: {},
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
            }
        },
        created: function () {
            this.devcDef.assetType = this.assetType || 0;
            //
            if (!Utils.isNoB(this.defId)) {
                this.getDevcDefDetail();
            } else {
                //
                if (Utils.isTrue(this.fiscalAudit)) {
                    this.devcDef.fiscalAuditState = 1;
                }
            }
        },
        methods: {
            checkDurableLife: function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('使用年限不可为空!'));
                } else {
                    let devcDef = this.devcDef;
                    if (devcDef.assetNature == 2) {
                        if (Utils.isNaturalStr(value)) {
                            callback();
                        } else {
                            callback(new Error('必须为大于等于0的整数!'));
                        }
                    } else {
                        if (Utils.isNaturalStr(value, true)) {
                            callback();
                        } else {
                            callback(new Error('必须为大于0的整数!'));
                        }
                    }
                }
            },
            // 查看资产定义详情
            getDevcDefDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.defId;
                //
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getMerchtDevcDefInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let devcDef = result.data;
                        //
                        if (Utils.isTrue(self.fiscalAudit)) {
                            devcDef.fiscalAuditState = 1;
                        }
                        self.devcDef = Utils.merge({}, devcDef);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        let devcDef = self.devcDef;
                        let resultData = {
                            id: self.defId,
                            normalized: true,
                            assetKindId: devcDef.assetKindId,
                            assetKindName: devcDef.assetKindName,
                            assetKindCode: devcDef.assetKindCode,
                            assetNature: devcDef.assetNature,
                            durableLife: devcDef.durableLife,
                            deprSpecId: devcDef.deprSpecId,
                            deprSpecCode: devcDef.deprSpecCode,
                            deprSpecName: devcDef.deprSpecName
                        };
                        if (Utils.isTrue(self.fiscalAudit)) {
                            resultData.fiscalAuditState = devcDef.fiscalAuditState;
                        }
                        result.type = 'info';
                        result.data = resultData;
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
            setAssetKind: function () {
                let self = this;
                openAssetKindListSelectDlg({checkBox: false, hasDeprSpec: true}, function (result, theDlg) {
                    theDlg.close();
                    let devcDef = self.devcDef;
                    devcDef.assetKindId = result.id;
                    devcDef.assetKindName = result.name;
                    devcDef.assetKindCode = result.code;
                    devcDef.assetNature = result.assetNature;
                    if (devcDef.assetNature != result.assetNature) {
                        devcDef.assetNature = result.assetNature;
                    }
                    devcDef.deprSpecId = result.deprSpecId;
                    devcDef.deprSpecCode = result.deprSpecCode;
                    devcDef.deprSpecName = result.deprSpecName;
                    //
                    self.devcDef = Utils.merge({}, devcDef);
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefFiscalSave.vue